// Theme: rose-quartz-core
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'rose-quartz-core',
  name: 'ROSE QUARTZ CORE',
  tagline: 'ROSE QUARTZ CORE',
  description: 'Cristal quartzo rosa com gradiente diagonal e brilho contido.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#1A0F14', '#F9A8D4', '#2A1820', '#FCE7F3'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 8%, transparent)'
    },
    shellClasses: 'font-sans theme-rose-quartz-core'
  },
  colorVars: {
    '--accent': '#F9A8D4',
    '--accent-foreground': '#1A0F14',
    '--background': '#1A0F14',
    '--border': '#8A3A60',
    '--card': '#2A1820',
    '--card-border-active': 'rgba(249, 168, 212, 0.42)',
    '--card-completed': '#2A1820',
    '--card-foreground': '#FCE7F3',
    '--card-glow': 'rgba(249, 168, 212, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A0F14',
    '--foreground': '#FCE7F3',
    '--hold-fill': '#F9A8D4',
    '--input': '#2A1820',
    '--modal-bg': '#1A0F14',
    '--modal-border': '#8A3A60',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A3A60',
    '--muted-foreground': '#FCE7F3',
    '--nav-active': '#F9A8D4',
    '--nav-bg': '#1A0F14',
    '--popover': '#2A1820',
    '--popover-foreground': '#FCE7F3',
    '--primary': '#F9A8D4',
    '--primary-foreground': '#1A0F14',
    '--ring': '#F9A8D4',
    '--secondary': '#8A3A60',
    '--secondary-foreground': '#FCE7F3',
    '--streak': '#F9A8D4',
    '--success': '#22C55E',
    '--success-foreground': '#1A0F14',
    '--xp': '#F9A8D4',
    '--xp-bg': '#2A1820'
  },
  resolvedVars: {
    '--accent': '#F9A8D4',
    '--accent-foreground': '#1A0F14',
    '--accent-foreground-hsl': '333 27% 8%',
    '--accent-foreground-oklch': 'from #1A0F14 l c h',
    '--accent-hsl': '327 87% 82%',
    '--accent-oklch': 'from #F9A8D4 l c h',
    '--background': '#1A0F14',
    '--background-hsl': '333 27% 8%',
    '--background-oklch': 'from #1A0F14 l c h',
    '--border': '#8A3A60',
    '--border-hsl': '332 41% 38%',
    '--border-oklch': 'from #8A3A60 l c h',
    '--border-w': '1px',
    '--card': '#2A1820',
    '--card-border-active': 'rgba(249, 168, 212, 0.42)',
    '--card-completed': '#2A1820',
    '--card-completed-hsl': '333 27% 13%',
    '--card-completed-oklch': 'from #2A1820 l c h',
    '--card-foreground': '#FCE7F3',
    '--card-foreground-hsl': '326 78% 95%',
    '--card-foreground-oklch': 'from #FCE7F3 l c h',
    '--card-glow': 'rgba(249, 168, 212, 0.08)',
    '--card-hsl': '333 27% 13%',
    '--card-oklch': 'from #2A1820 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A0F14',
    '--destructive-foreground-hsl': '333 27% 8%',
    '--destructive-foreground-oklch': 'from #1A0F14 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#FCE7F3',
    '--foreground-hsl': '326 78% 95%',
    '--foreground-oklch': 'from #FCE7F3 l c h',
    '--hold-fill': '#F9A8D4',
    '--hold-fill-hsl': '327 87% 82%',
    '--hold-fill-oklch': 'from #F9A8D4 l c h',
    '--input': '#2A1820',
    '--input-hsl': '333 27% 13%',
    '--input-oklch': 'from #2A1820 l c h',
    '--modal-bg': '#1A0F14',
    '--modal-bg-hsl': '333 27% 8%',
    '--modal-bg-oklch': 'from #1A0F14 l c h',
    '--modal-border': '#8A3A60',
    '--modal-border-hsl': '332 41% 38%',
    '--modal-border-oklch': 'from #8A3A60 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A3A60',
    '--muted-foreground': '#FCE7F3',
    '--muted-foreground-hsl': '326 78% 95%',
    '--muted-foreground-oklch': 'from #FCE7F3 l c h',
    '--muted-hsl': '332 41% 38%',
    '--muted-oklch': 'from #8A3A60 l c h',
    '--nav-active': '#F9A8D4',
    '--nav-active-hsl': '327 87% 82%',
    '--nav-active-oklch': 'from #F9A8D4 l c h',
    '--nav-bg': '#1A0F14',
    '--nav-bg-hsl': '333 27% 8%',
    '--nav-bg-oklch': 'from #1A0F14 l c h',
    '--popover': '#2A1820',
    '--popover-foreground': '#FCE7F3',
    '--popover-foreground-hsl': '326 78% 95%',
    '--popover-foreground-oklch': 'from #FCE7F3 l c h',
    '--popover-hsl': '333 27% 13%',
    '--popover-oklch': 'from #2A1820 l c h',
    '--primary': '#F9A8D4',
    '--primary-foreground': '#1A0F14',
    '--primary-foreground-hsl': '333 27% 8%',
    '--primary-foreground-oklch': 'from #1A0F14 l c h',
    '--primary-hsl': '327 87% 82%',
    '--primary-oklch': 'from #F9A8D4 l c h',
    '--radius': '12px',
    '--ring': '#F9A8D4',
    '--ring-hsl': '327 87% 82%',
    '--ring-oklch': 'from #F9A8D4 l c h',
    '--secondary': '#8A3A60',
    '--secondary-foreground': '#FCE7F3',
    '--secondary-foreground-hsl': '326 78% 95%',
    '--secondary-foreground-oklch': 'from #FCE7F3 l c h',
    '--secondary-hsl': '332 41% 38%',
    '--secondary-oklch': 'from #8A3A60 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 8%, transparent)',
    '--streak': '#F9A8D4',
    '--streak-hsl': '327 87% 82%',
    '--streak-oklch': 'from #F9A8D4 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#1A0F14',
    '--success-foreground-hsl': '333 27% 8%',
    '--success-foreground-oklch': 'from #1A0F14 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(327 87% 82% / 0.15)',
    '--xp': '#F9A8D4',
    '--xp-bg': '#2A1820',
    '--xp-bg-hsl': '333 27% 13%',
    '--xp-bg-oklch': 'from #2A1820 l c h',
    '--xp-hsl': '327 87% 82%',
    '--xp-oklch': 'from #F9A8D4 l c h'
  }
}
